import { useEffect } from "react";
import { KeyboardEventKeys } from "../../typings/types";
import { disableAllElementsFocusInWrapper, getFocusableElementsInWrapper, getNextFocusable, getPrevFocusable } from "../useFocusWrapper";
import useKeyboardNavigation from "../useKeyboardNavigation";
var disableFocusableElementsInSlidesClones = function disableFocusableElementsInSlidesClones(sliderRef) {
  var _sliderRef$current;
  var list = sliderRef === null || sliderRef === void 0 || (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 || (_sliderRef$current = _sliderRef$current.innerSlider) === null || _sliderRef$current === void 0 ? void 0 : _sliderRef$current.list;
  if (!list) return;
  var slidesCloned = list.querySelectorAll(".slick-slide.slick-cloned");
  slidesCloned.forEach(function (slide) {
    disableAllElementsFocusInWrapper(slide, true);
  });
};
var useReactSlickSlider = function useReactSlickSlider(sliderRef, focusWrapperRef, isSliderFocus, slidesCount) {
  var _useKeyboardNavigatio = useKeyboardNavigation(),
    isKeyboardNavigation = _useKeyboardNavigatio.isKeyboardNavigation;
  var handleSliderAfterChange = function handleSliderAfterChange(index) {
    var _focusWrapperRef$curr;
    if (!isKeyboardNavigation || !isSliderFocus) {
      return;
    }
    var activeSlide = (_focusWrapperRef$curr = focusWrapperRef.current) === null || _focusWrapperRef$curr === void 0 ? void 0 : _focusWrapperRef$curr.querySelector("[data-index=\"".concat(index, "\"] .focusable-slide-wrapper"));
    activeSlide === null || activeSlide === void 0 || activeSlide.focus();
  };
  useEffect(function () {
    disableFocusableElementsInSlidesClones(sliderRef);
  }, [sliderRef]);
  useEffect(function () {
    var handleSliderOnKeyDown = function handleSliderOnKeyDown(event) {
      if (event.key === KeyboardEventKeys.ESC) {
        event.stopPropagation();
        event.preventDefault();
      }

      // we stopped focus which move from one slide to another and change active slide
      if (event.key === KeyboardEventKeys.TAB) {
        var _slick$list$querySele, _slick$list, _focusWrapperRef$curr2, _focusWrapperRef$curr3;
        var slick = sliderRef.current.innerSlider;
        if (!slick) {
          return;
        }
        var activeSlides = (_slick$list$querySele = (_slick$list = slick.list) === null || _slick$list === void 0 ? void 0 : _slick$list.querySelectorAll(".slick-slide.slick-active")) !== null && _slick$list$querySele !== void 0 ? _slick$list$querySele : [];
        if (activeSlides.length === 0) {
          return;
        }
        var currentSlideDataIndexAttr = activeSlides[0].getAttribute("data-index");
        if (!currentSlideDataIndexAttr) {
          return;
        }
        var currentSlideIndex = parseInt(currentSlideDataIndexAttr, 10);
        if (Number.isNaN(currentSlideIndex)) {
          return;
        }
        var currentSlide = activeSlides[0];
        var slideFocusableElements = getFocusableElementsInWrapper(currentSlide);
        if (!slideFocusableElements.length) {
          return;
        }
        var firstFocusableElement = slideFocusableElements[0];
        var lastFocusableElement = slideFocusableElements[slideFocusableElements.length - 1];
        var slideWrapper = currentSlide.querySelector(".focusable-slide-wrapper");
        var isForwardDirection = !event.shiftKey;
        var currentFocusElement = document.activeElement;

        // when click TAB on last element in slide, active next slide
        if (isForwardDirection && currentFocusElement === lastFocusableElement && currentSlideIndex !== slidesCount - 1) {
          event.preventDefault();
          sliderRef.current.slickNext();
          return;
        }

        // when click SHIFT + TAB on first element in slide, active prev slide
        if (!isForwardDirection && currentFocusElement === firstFocusableElement && currentSlideIndex !== 0) {
          event.preventDefault();
          sliderRef.current.slickPrev();
          return;
        }
        if (!slideWrapper || !focusWrapperRef.current || focusWrapperRef.current.contains(currentFocusElement)) {
          return;
        }

        // when entry to slider by TAB, active first slide
        var nextFocusableElement = getNextFocusable(document.activeElement);
        if (nextFocusableElement && isForwardDirection && (_focusWrapperRef$curr2 = focusWrapperRef.current) !== null && _focusWrapperRef$curr2 !== void 0 && _focusWrapperRef$curr2.contains(nextFocusableElement)) {
          var _sliderRef$current2;
          event.preventDefault();
          sliderRef === null || sliderRef === void 0 || (_sliderRef$current2 = sliderRef.current) === null || _sliderRef$current2 === void 0 || _sliderRef$current2.slickGoTo(0, true);
          slideWrapper.focus();
          return;
        }

        // when entry to slider by SHIFT + TAB, active last slide
        var prevFocusableElement = getPrevFocusable(document.activeElement);
        if (prevFocusableElement && !isForwardDirection && (_focusWrapperRef$curr3 = focusWrapperRef.current) !== null && _focusWrapperRef$curr3 !== void 0 && _focusWrapperRef$curr3.contains(prevFocusableElement)) {
          var _sliderRef$current3;
          event.preventDefault();
          sliderRef === null || sliderRef === void 0 || (_sliderRef$current3 = sliderRef.current) === null || _sliderRef$current3 === void 0 || _sliderRef$current3.slickGoTo(slidesCount - 1, true);
          slideWrapper.focus();
        }
      }
    };
    window.addEventListener("keydown", handleSliderOnKeyDown);
    return function () {
      window.removeEventListener("keydown", handleSliderOnKeyDown);
    };
  }, [isSliderFocus]);
  return {
    handleSliderAfterChange: handleSliderAfterChange,
    sliderUpdateProps: {
      speed: isSliderFocus && isKeyboardNavigation ? 0 : 500,
      waitForAnimate: !(isSliderFocus && isKeyboardNavigation)
    }
  };
};
export default useReactSlickSlider;